module.exports = __webpack_public_path__ + "static/china-2a0124c704d84fa1ccb1c2b3e4b1b9b2.jpg";